import { getService } from 'react-in-angularjs';

type SetRouteParamsOptions = {
  replace?: boolean;
};

export const setRouteParams = (
  params: Record<string, string | null>,
  options?: SetRouteParamsOptions,
) => {
  const $location = getService('$location');
  const $rootScope = getService('$rootScope');

  const currentParams = $location.search();

  $location.search({
    ...currentParams,
    ...params,
  });

  if (options?.replace) {
    $location.replace();
  }

  $rootScope.$applyAsync();
};
